import { OtherComponent } from './other.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupportComponent } from './support.component';
import { FaqComponent } from './faq.component';
import { AuthGuard } from 'app/modules/guard/auth.guard';
import { ClientErrorComponent } from 'app/modules/clienterror/client-error.component';

const otherRoutes: Routes = [
  { 
    path: 'other', 
    component: OtherComponent,
    children: [
      { path: 'support', component: SupportComponent },
      { path: 'faq', component: FaqComponent, canActivate: [AuthGuard] },
      { path: '**', component: ClientErrorComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(otherRoutes)],
  exports: [RouterModule],
})
export class OtherRoutingModule { }

